import { Box, Typography } from "@mui/material";
import React from "react";
import { usePainelContext } from "./PainelContext";

const CardV = ({ valor, label, color, onClick, mapValoes, style, selected }) => {
    let clic =
        onClick ||
        (() => {
            console.log("clic", label);
        });
    return (
        <div
            onClick={clic}
            style={{
                boxShadow: selected ? "0 4px 8px 0 rgba(0, 0, 0, 0.9)" : "0 4px 8px 0 rgba(0, 0, 0, 0.5)",
                borderRadius: 5,
                backgroundColor: color,
                display: "flex",
                padding: 15,
                flexDirection: "column",
                minWidth: 150,
                ...style,
            }}
        >
            <Typography variant="h6">{label}</Typography>
            {valor !== undefined && <Typography variant="h3">{valor ? valor : 0}</Typography>}
            <div style={{ display: "flex", flexWrap: "wrap" }}>
                {Object.keys(mapValoes || {}).map((k, i) => {
                    return (
                        <div key={i} style={{ display: "flex", flex: "1 1 100px" }}>
                            <Typography>
                                {mapValoes[k]} {k}
                            </Typography>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default function CardTabs({ tab, setTab, rodada }) {
    const { inscricoes, reunioes } = usePainelContext();
    // console.log('CardTabs inscricoes',inscricoes)
    let ancoras = (inscricoes || []).filter((f) => {
        return f.tipo === "ÂNCORA";
    });

    let flutuantes = (inscricoes || []).filter((f) => {
        return f.tipo !== "ÂNCORA";
    });
    const geraMapInsc = (list) => {
        return {
            Inscritos: list.filter((i) => i.status === "INSCRITO").length,
            Presentes: list.filter((i) => i.statusEvento === "PRESENTE" && i.status !== "CANCELADO").length,
            Saiu: list.filter((i) => i.statusEvento === "SAIU" && i.status !== "CANCELADO").length,
            Ausente: list.filter((i) => i.statusEvento === "AUSENTE" && i.status !== "CANCELADO").length,
        };
    };

    const geraMapReunioes = (reunioes) => {
        let nr = reunioes.length;
        let nh = (rodada.possiveisReunioes?.length || 0) * (rodada.mesas?.length || 0);
        let hp = reunioes.filter(
            (r) => r && r.horario && r.horario.horario && new Date(r.horario.horario) < new Date()
        ).length;
        let pr = reunioes.filter(
            (r) => r && r.horario && r.horario.horario && new Date(r.horario.horario) > new Date()
        ).length;

        return {
            Agendadas: nr,
            Livres: nh - nr,
            Realizadas: hp,
            Proximas: pr,
        };
    };
    return (
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
            <CardV
                style={{ flex: 0.5, cursor: "pointer" }}
                label="INSCRITOS"
                mapValoes={geraMapInsc(inscricoes)}
                onClick={() => setTab(0)}
                selected={tab === 0}
                color="#c333ff"
            />
            <CardV
                style={{ flex: 0.5, cursor: "pointer" }}
                label="ÂNCORAS"
                mapValoes={geraMapInsc(ancoras)}
                onClick={() => setTab(1)}
                selected={tab === 1}
                color="#0092CB"
            />
            <CardV
                style={{ flex: 0.5, cursor: "pointer" }}
                label="FLUTUANTES"
                mapValoes={geraMapInsc(flutuantes)}
                onClick={() => setTab(2)}
                selected={tab === 2}
                color="#0070FF"
            />
            <CardV
                style={{ flex: 0.5, cursor: "pointer" }}
                label="REUNIÕES"
                onClick={() => setTab(3)}
                selected={tab === 3}
                mapValoes={geraMapReunioes(reunioes)}
                color="#00FF00"
            />
            {/*"#008D7F" />*/}
        </Box>
    );
}
